<template>
  <div class="reg-container">
    <div class="title-box">
      <div class="title-item">
        <label>注册账户</label>
        <span>Registered account</span>
      </div>
    </div>
    <div class="head-box">
      <input type="text" v-model="userobj.name" placeholder="请输入姓名" />
      <input type="text" v-model="userobj.unit" placeholder="请输入单位名称" />
      <input type="text" v-model="userobj.phone" placeholder="请输入联系方式" />
    </div>
    <div class="body-box">
      <div class="public-btn" @click.stop="submit">
        <span>下一步</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      userobj: {
        uid: "",
        name: "",
        unit: "",
        phone: ""
      },
      clicked: false
    };
  },
  methods: {
    submit() {
      if (this.clicked) {
        return;
      }
      const that = this;
      let _opid = this.$storage.get("openid");
      console.log("_opid:", _opid);
      /* eslint-disable */
        let nameflag = /^[A-Za-z0-9\u4e00-\u9fa5\.·]{1,10}$/.test(
                this.userobj.name
        );
        let phoneflag = /^1[34578]\d{9}$/.test(this.userobj.phone);
        if (!this.userobj.name) {
          this.$notify({ type: "danger", message: "请输入姓名！" });
          return;
        }
        if (!this.userobj.unit) {
          this.$notify({ type: "danger", message: "请输入单位名称！" });
          return;
        }
        if (!this.userobj.phone) {
          this.$notify({ type: "danger", message: "请输入联系方式！" });
          return;
        }
        if (!nameflag) {
          this.$notify({ type: "danger", message: "姓名格式错误！" });
          return;
        }
        if (!phoneflag) {
          this.$notify({ type: "danger", message: "手机号格式错误！" });
          return;
        }
        this.clicked = true;
        const rgsObj = {
          wxOpenId: _opid,
          nickName: that.userobj.name,
          unit: that.userobj.unit,
          accountId: that.userobj.phone
        }
        this.$storage.set('rgsUserInfo',rgsObj)
        this.$router.push('/permissions')
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "~@/styles/index";
  .reg-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    width: 100%;
    .title-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 18%;
      width: 100%;
      background: url("./image/registered.png") no-repeat center;
      background-size: 100% 100%;
      .title-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        height: 100%;
        width: 95%;
        label {
          font-size: px2rem(20);
          color: #d9d9d9;
        }
        span {
          margin-top: px2rem(3);
          font-size: px2rem(13);
          color: #717171;
        }
      }
    }
    .head-box {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      height: 25%;
      width: 95%;
      background-image: linear-gradient(180deg, #2a2e32 0%, #34393e 100%);
      border-radius: 8px;
      input {
        width: px2rem(315);
        height: px2rem(66);
        border: 0;
        border-bottom: 1px solid rgb(66, 70, 73);
        font-size: px2rem(16);
        color: #ffffff;
        background-color: rgba(0, 0, 0, 0);
      }
      > input:last-child {
        border: 0;
      }
      input::placeholder {
        color: #717171;
      }
    }
    .body-box {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 57%;
      width: 95%;
      background-color: rgba(0, 0, 0, 0);
    }
  }
</style>
